import React, { useState, useEffect } from 'react';
import { Paper } from '@material-ui/core';

type PutTransitionProps = {
  style?: React.CSSProperties;
  newborn: boolean;
  done: () => void;
}
const PutTransition: React.FC<PutTransitionProps> = ({ children, style, newborn, done }) => {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    if (!newborn) return;
    setTimeout(() => {
      setDisplay(true);
      done();
    }, 300)
  }, [newborn])

  return (
    <div style={{ opacity: !display && newborn ? 0 : 1 }}>
      <Paper
        elevation={newborn ? 8 : 0}
        style={{
          ...style,
          backgroundColor: '#11ffee00',
          transform: newborn ? 'scale(1.1)' : undefined,
          transition: '300ms',
          pointerEvents: newborn ? 'none' : undefined
        }}
      >
        { children }
      </Paper>
    </div>
  );
}

export default PutTransition;
